module.exports = __webpack_public_path__ + "static/media/Avatar3.25f1a825.svg";